import { calculateLocatinVars } from '../../../libs/browser';
import { formatDate } from '../../../libs/date';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import IconBenefitsRed from '../../../assets/hkdc/icons/BenefitsRedIcon';
import LogoFooterComponent from '../../../components/LogoFooterComponent';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import QRCode from 'react-qr-code';
import React, { useContext, useEffect, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function WebVoucherDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const { init, me, dispatch, lang } = useContext(Context);

  const [data, setData] = useState(null);
  const [vouchersData, setVouchersData] = useState([]);

  const getItem = async (page) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getItems({
        page,
        pageSize: 1000,
        status: 'available'
      });
      setVouchersData((prevData) => [...prevData, ...(response?.list ?? []).filter((i) => !(prevData.find((p) => p.id === i.id)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) {
      getItem(1);
      setData(location.state?.data);
    }
  }, [init, me, navigate]);

  return (
    (
      <div className='web-voucher-detail-page'>
        {
          data &&
          <div className="gray-block content-container">

            <div className="section-max-container section">
              <div className="info-outer-container">
                {
                  vouchersData.length > 0 && vouchersData.map((item, index) => {
                    return (
                      <div key={index} className='info-container' style={{ display: item.token !== data ? 'none' : undefined }}>
                        <div className="bar-title-container">
                          <IconBenefitsRed
                            className="icon"
                            size="large" />
                          <div className="title">
                            {item?.title?.[lang]}
                          </div>
                        </div>
                        <div className="qr-container">
                          <div className="qr-img-cont">
                            <QRCode className='qrcode' size={512} value={item?.token} />
                            <div className="id-container">
                              {`ID: ${item?.token}`}
                            </div>
                          </div>
                          <div className="time-text">
                            {`${t('vouchers.expiry')}${formatDate(item?.expire_at, lang)}`}
                          </div>
                        </div>
                        <div className="desc-text-container">
                          <div className="top-text-container">
                            <div className="title">
                              {`${t('vouchers.applicable')}`}
                            </div>
                            <div className="text">
                              {item?.stores?.length > 0 ? `${item?.stores.reduce((acc, val, index, arr) => {
                                return acc += `${val?.title?.[lang]}${index === arr.length - 1 ? '' : ', '}`;
                              }, '')}.` : ''}
                            </div>
                          </div>
                          <div className="bottom-text-container">
                            <div className="title">
                              {`${t('vouchers.description')}`}
                            </div>
                            <div className="text">
                              { item?.details?.[lang] &&
                                <CommonDescription data={item?.details?.[lang]} />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                }
                <div className="page-count">
                  <Pagination
                    count={vouchersData.length}
                    variant="outlined"
                    shape="rounded"
                    value={vouchersData.findIndex((item) => item.token === data) + 1}
                    onChange={(event, value) => {
                      const voucherToken = vouchersData[value - 1].token;
                      if (data === voucherToken) return;
                      setData(voucherToken);
                    }}
                    renderItem={(item) => {
                      return (
                        <PaginationItem
                        sx={{
                          borderRadius: '0',
                          border: '0.125rem solid #A1A3A5',
                          minWidth: '2.8125rem',
                          height: '2.8125rem',
                          padding: '0.25rem',
                          color: '#A1A3A5',
                          fontWeight: '700',
                          fontSize: '1rem',
                          '&.Mui-selected': {
                            border: '0.125rem solid #004899',
                            backgroundColor: '#004899',
                            color: 'white'
                          }
                        }}
                          {...item}
                        />
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="black-block full-width">
              <LogoFooterComponent />
            </div>
          </div>
        }
      </div>
    )
  );
}